import { createContext, useContext } from "react";
import { colorDeLaCompetencia } from "@/lib/competencias.mjs";

/**
 * Una burbuja del chat del mentor, con su paleta. La pintan DOS sitios y por eso vive aquí.
 *
 * DE DÓNDE SALE. El 19 de octubre de 2026, montando la portada nueva, Gabri vio la lección
 * simulada al lado del titular y dijo que le gustaba más que la de verdad. La de verdad tenía
 * burbujas BLANCAS sobre un fondo casi blanco (`#faf9f7`) con sombra para despegarlas, y la
 * respuesta del alumno en rojo. Dos problemas: el contraste entre burbuja y fondo lo sostenía
 * una sombra, y el rojo —que en esta casa significa «esto es Alpha» y «esto importa»— se
 * gastaba en cada cosa que escribe un alumno.
 *
 * LO QUE CAMBIA, Y SOLO ESTO: el fondo de la ventana pasa a blanco, la burbuja del mentor a
 * `alpha-off` y la del alumno a negro. Las cinco fases del ciclo y los tres botones del pie
 * —continuar, más despacio, hacer una pregunta— NO se tocan: son el mando del alumno y
 * funcionan.
 *
 * Y POR QUÉ ES UNA PIEZA Y NO UNAS CLASES COPIADAS. La portada enseña una lección de verdad;
 * si la pinta con sus propias clases, el día que esto cambie habrá dos chats distintos y el
 * visitante verá uno antes de registrarse y otro después. Una vara, un sitio.
 *
 * EL 3 DE NOVIEMBRE DE 2026 CAMBIÓ LA PALETA, otra vez por Gabri: el negro del alumno contra el
 * blanco tenía demasiado contraste. La ventana es el color de la competencia en claro, el mentor
 * ese color en oscuro con letra blanca y el alumno, blanco con letra negra. Se probó al revés
 * —ventana oscura, burbujas pálidas— y las dos partes de la conversación casi no se distinguían.
 *
 * Y LA CARA DEL MENTOR SÓLO VA EN EL ENCABEZADO, desde ese mismo día: al lado de cada mensaje
 * quitaba ancho y no decía nada que no se supiera.
 *
 * LA COMPETENCIA LLEGA POR CONTEXTO y no por una propiedad, porque hay una burbuja a tres pisos
 * de la ventana (`MiraElFallo`, dentro de la actividad) que de la lección no sabe nada.
 */
export const CompetenciaDelChat = createContext(null);

export function Burbuja({ de, ancha = false, children }) {
  const delAlumno = de === "alumno";
  const color = colorDeLaCompetencia(useContext(CompetenciaDelChat));
  return (
    <div
      className={`${ancha ? "w-full max-w-[92%] md:max-w-[80%]" : "max-w-[80%]"} rounded-[24px] px-4 py-2.5 text-[14px] leading-relaxed ${
        delAlumno
          ? "bg-white text-alpha-black border border-alpha-black/10 rounded-br-lg"
          : `${color.mensaje} text-white rounded-bl-lg`
      }`}
    >
      {children}
    </div>
  );
}

/** La fila entera: a la izquierda si habla el mentor, a la derecha si habla el alumno. */
export function FilaDeChat({ de, children, ...resto }) {
  return (
    <div className={`flex ${de === "alumno" ? "justify-end" : "justify-start"}`} {...resto}>
      {children}
    </div>
  );
}

export default Burbuja;
